function umfradio() {


  // Episode Search
  var theepisode = $('#the-episode');
  if ( !! theepisode.length ) {

      $.extend($.expr[":"], {
          "containsIN": function(elem, i, match, array) {
              return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
          }
      });

      var updateList = function() {

          var allRows = $('#episode-list article');
          allRows.removeClass('hiddenRow');
          var clickedText = theepisode.val();
          var theCounter = 0;

          allRows.each(function(){
        //$(this).contains
        if( ! $(this).is(':containsIN("'+clickedText+'")'))  {
            $(this).addClass('hiddenRow');
        } else {
            theCounter = theCounter +1;
        }
    });
      }

      updateList();

      theepisode.on('keyup', function(e) {
          updateList();
      });

      theepisode.on('blur', function(e) {
          updateList();
      });

  }
  // Station Search
  var thestation = $('#the-station');
  if ( !! thestation.length ) {

      $.extend($.expr[":"], {
          "containsIN": function(elem, i, match, array) {
              return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
          }
      });

      var updateList = function() {

          var allRows = $('.stable tbody tr');
          allRows.removeClass('hiddenRow');
          var clickedText = thestation.val();
          var theCounter = 0;

          allRows.each(function(){
        //$(this).contains
        if( ! $(this).is(':containsIN("'+clickedText+'")'))  {
            $(this).addClass('hiddenRow');
        } else {
            theCounter = theCounter +1;
        }
    });
      }

      updateList();

      thestation.on('keyup', function(e) {
          updateList();
      });

      thestation.on('blur', function(e) {
          updateList();
      });

  }

  // Stations Listing
  if( !! $("#station-list").length) {

      $('.bulkinfo').on('click', function(e){

          e.preventDefault();

          var el = $(this);
          var bulklinks = el.parent().parent().parent().find('.bulkinfo');
          var elWrap = el.parent().parent().parent();
          var target = '.'+$(this).data('target');
        //log(target);


        if( elWrap.hasClass('active') ) {
            bulklinks.find('strong').text('Click for Details');
            elWrap.removeClass('active');
            $(target).slideUp(300, 'easeInOutExpo');
        } else {
            bulklinks.find('strong').text('Hide Details');
            elWrap.addClass('active');
            $(target).slideDown(300, 'easeInOutExpo');
        }

    });

      // If hash exists, click the hash's relevant link
      if(window.location.hash) {

          var hash = window.location.hash;

          if (hash === '#' || hash === 'https:#' || hash === '') { return; }

          var destination = $(hash).offset().top || 0;

          $(hash).find('.opener').trigger('click');
          setTimeout(function() {
              $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, 1200, 'easeInOutExpo', function() {
              //window.location.hash = hash;
          });
              setTimeout(function() {
              }, 1200);
          }, 1200);
      }


  }


  if( !! $(".track-listing li a").length) {
    //$(".track-listing li a").attr('target','_blank');
}

if( !! $("#episode-list").length) {

    $elist = $('#episode-list');

    var placeholder = $elist.data('aimg');
    var aimg;

      //log(placeholder);

      // click to load an episode
      $('#episode-list article h2 a').on('click', function(e) {

          e.preventDefault();

          var el = $(this),
          output = '',
          item = el.parent().parent();
          ec = el.parent().parent().find('div.episode-content'),
          link = el.parent().parent().data('link');
          slug = el.parent().parent().parent().data('slug');


          link = link + '?json=1';
        //log(link);

        // if the episode is already active, then close it
        if(el.hasClass('active') == true) {
            el.removeClass('active');
            ec.removeClass('active');
            ec.slideUp(500, 'easeInOutExpo');
            return;
        }

        // load json content
        $.get( link , function() {})
        .done(function(data) {

            var content = data[0];

            output += '<div class="lbreak3 op50"></div>';

            if(content.embed_code) {
                var embed = content.embed_code;
              //log(embed);
              embed = embed.replace('http:', 'https:');
              embed = 'https://www.mixcloud.com/widget/iframe/?feed='+embed+'&hide_cover=1';
              output += '<div class="embed mb25"><iframe width="100%" height="120" src="'+embed+'" frameborder="0"></iframe></div>';
              output += '<a class="btn-main gray-btn btn-lg ml25" href="javascript: open_window(\''+embed+'\',600,120);">Popout Audio Player <span class="fas fa-chevron-right"></span></a>';
              if(content.track_listings) { output += '<a href="#'+content.name+'" data-fancybox="images" class=" btn-main gray-btn btn-lg btn-view-track-listing ml25">View Track Listing <span class="fas fa-chevron-right"></span></a>'; };
          }

          if(content.info) {
              output += '<h2 class="padl25 padb25">'+content.info+'</h2>';
          }

          if(content.artists) {
              output += '<div class="artists clearfix">';
              $.each( content.artists, function( key, val ) {

                  if(val.image) {
                      aimg = val.image;
                  } else {
                      aimg = placeholder;
                  }

                  output += '<a href="'+val.url+'"><img src="'+aimg+'"><strong>'+val.title+'</strong></a>';
              });
              output += '</div>';
          }

          if(content.track_listings) {

              output += '<div class="hide ml25 clearfix"><div id="'+content.name+'" class="lboxtracks" >';

              $.each( content.track_listings, function( key, val ) {
                  log(val);
                  output += '<h3 class="lboxtitle">'+val.title+'</h3><div class="lbreak53 op50"></div>';
                  output += '<div class="tracks lboxtracks">'+val.content+'</div>';

              });

              output += '</div></div>';
          }

          ec.html(output);
          $elist.find('article div.episode-content.active').slideUp(300, 'easeInOutExpo');
          $elist.find('article.active').removeClass('active');
          $elist.find('article h2 a.active').removeClass('active');


          el.addClass('active');
          ec.addClass('active');
          setTimeout(function() {
              ec.slideDown(500, 'easeInOutExpo');
          },100);


      })

    })


      var $slug = $elist.data('slug');

      if($slug == 'schedule') {
          setTimeout(function(){ $elist.find('article:nth-child(2) h2 a').trigger('click');   }, 500);
      }
      //$('#episode-list article:nth-child(2) h2 a').addClass('active');
      //$('#episode-list article:nth-child(2) h2 a').trigger('click');


  }


  if ( !! $('#radio-search').length ) {

      $.extend($.expr[":"], {
          "containsIN": function(elem, i, match, array) {
              return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
          }
      });

      var updateList = function() {

          var allRows = $('div.station');
          allRows.removeClass('hiddenRow');
          var clickedText = $('#radio-search').val();
          var theCounter = 0;

          allRows.each(function(){
        //$(this).contains
        if( ! $(this).is(':containsIN("'+clickedText+'")'))  {
            $(this).addClass('hiddenRow');
        } else {

            theCounter = theCounter +1;
        }
    });

          $('#fts strong').html(theCounter);

      }

      updateList();

      $('#radio-search').on('keyup', function(e) {
          updateList();
      });

      $('#radio-search').on('blur', function(e) {
          updateList();
      });
  }



  $('#station-toggle').on('click', function(e){
      e.preventDefault();
      $('#station-wrap').slideToggle(300);
  })

};
